import { useState } from 'react';
import { useRachelChangedValue } from '../../../../rachel/hooks/useRachelChangedValue';
import { UseOrderDetailsRachelRevealParams } from '../orderObjectPage.types';

export const useOrderDetailsRachelReveal = ({
  generalDataKey,
  isOpenByDefault,
}: UseOrderDetailsRachelRevealParams) => {
  const [isDetailsOpen, setIsDetailsOpen] = useState(isOpenByDefault);
  const [wasChangedByRachel, setWasChangedByRachel] = useState(false);
  const { isChanged } = useRachelChangedValue(generalDataKey);

  if (isChanged !== wasChangedByRachel) {
    setWasChangedByRachel(isChanged);
    if (isChanged) {
      setIsDetailsOpen(true);
    }
  }

  return { isDetailsOpen, onDetailsOpenChange: setIsDetailsOpen };
};
